// Layout.tsx
import Navbar from './Navbar';
import './LayoutComponent.css';
import { LayoutProps } from '../../types/LayoutComponent.types';
import { NewsComponent } from '../other/NewsComponent';

const LayoutComponent = ({ children, pageName }: LayoutProps) => {
    return (
        <div className='layout'>
            <Navbar />
            <NewsComponent />
            <div className='main-frame'>
                <h1 className='page-title'>{pageName}</h1>
                {children}
            </div>
        </div>
    );
};

export default LayoutComponent;
